<template>
    <div>

        <section class="feature-section">
            <div class="container">
                <div class="row">

                  <div class="col-12 align-left">

                    <h2>Terms and Conditions</h2>

                    <h4>We try not to be weird, and treat people how we'd like to be treated.</h4>

                    <em>Here's the official stuff:</em>
                    <p><router-link to="/terms/refunds">Refunds</router-link></p>
                    <p><router-link to="/terms/eula">End User License Agreement</router-link></p>

                    <p><router-link to="/terms/privacy">Privacy Policy</router-link></p>
                    <p><router-link to="/terms/website-terms">Website Terms of Use</router-link></p>
                    <p><router-link to="/terms/disclaimer">Disclaimer</router-link></p>

                  </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'PaulHudson',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

